"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const clsx = require("../../../../chunks/clsx-CBkIpawf.js");
const foundations_icons_Icon = require("../../../../foundations/icons/Icon.js");
const Toggletip_module = require("../../../../chunks/Toggletip.module-DA5jkCaB.js");
const ToggletipIcon = ({ isActive, variant }) => {
  const size = 16;
  return /* @__PURE__ */ jsxRuntime.jsxs(
    "div",
    {
      className: clsx.clsx(
        Toggletip_module.styles.toggletipIcon,
        Toggletip_module.styles[`toggletip-${variant}-icon`],
        isActive && Toggletip_module.styles[`toggletip-${variant}-active`]
      ),
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(
          foundations_icons_Icon.Icon,
          {
            variant: "Info",
            className: clsx.clsx(isActive && Toggletip_module.styles.toggletipIconHidden),
            "aria-hidden": "true",
            width: size,
            height: size
          }
        ),
        /* @__PURE__ */ jsxRuntime.jsx(
          foundations_icons_Icon.Icon,
          {
            variant: "InfoFilled",
            className: clsx.clsx(!isActive && Toggletip_module.styles.toggletipIconHidden),
            "aria-hidden": "true",
            width: size,
            height: size
          }
        )
      ]
    }
  );
};
exports.ToggletipIcon = ToggletipIcon;
